import React, { useState, useEffect } from "react";
import SingleMAP2 from "./SingleMAP2";
import { url } from "../utils/baseurl";
export default function CurrentLocationAlert() {
  const [coordinates, setCoordinates] = useState("");
  const [latitude, setlatitude] = useState("");
  const [longitude, setlongitude] = useState("");
  const [alertinfo, setAlertInfo] = useState("");

  useEffect(() => {


    console.log("hi")
    // Check if geolocation is available in the browser
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          const coordinatesString = `${longitude},${latitude}`;
          setCoordinates(coordinatesString);

         
          getPositionwisealert(latitude,longitude);
          getPositionwisealert(latitude,longitude);
       
        },
        (error) => {
          console.error("Error getting geolocation:", error);
        }
      );
    } else {
      console.error("Geolocation is not available in this browser.");
    }
  }, []);




  async function position(){







    
  }

  async function getPositionwisealert(a,b) {

    console.log(a,b,"hey")

    const response = await fetch(
      `${url}/FetchLocationWiseAlerts?lat=${a}&long=${b}&radius=20`
    );
    const data = await response.json();
    console.log(data)

 
    if (data.alerts.length > 0) {
      setAlertInfo(data.alerts);

    } else {
      setAlertInfo(null);
    }
  }

  return (
    <div>
      {coordinates !== "" ? (
        <>
          <div className="w-full sm:w-1/2 bg-cream rounded-lg shadow-lg p-4">
          {/* <SingleMAP2 coordinate="74.51905667788769,15.882675787447672" colour="orange" /> */}
            <SingleMAP2 coordinate={coordinates} colour="orange" />
          </div>

          {alertinfo ? (
            <div
              className={`info-box p-4 rounded-md shadow-lg mt-4 sm:w-[200px] md:w-[300px] lg:w-[400px] ${alertinfo[0]?.severity_color}-bg`}
            >
              <h4
                className={`text-${alertinfo[0]?.severity_color}-800 font-semibold text-lg mb-2`}
              >
                ALERT FOUND
              </h4>
              <div className="mb-4">
                <div className="mb-2">
                  <p className="text-gray-800 font-semibold">Area:</p>
                  <p className={`text-${alertinfo[0]?.severity_color}-800`}>
                    {alertinfo[0]?.area_description}
                  </p>
                </div>
                <div className="mb-2">
                  <p className="text-gray-800 font-semibold">Disaster Type:</p>
                  <p className={`text-${alertinfo[0]?.severity_color}-800`}>
                    {alertinfo[0]?.disaster_type}
                  </p>
                </div>
                <div className="mb-2">
                  <p className="text-gray-800 font-semibold">Severity:</p>
                  <p
                    className={`text-${alertinfo[0]?.severity_color}-800 font-semibold`}
                  >
                    {alertinfo[0]?.severity_color === "yellow" ? (
                      <span className="text-yellow-600">LOW</span>
                    ) : alertinfo[0]?.severity_color === "red" ? (
                      <span className="text-red-600">HIGH</span>
                    ) : (
                      <span className="text-orange-600">MEDIUM</span>
                    )}
                  </p>
                </div>
                <div className="mb-2">
                  <p className="text-gray-800 font-semibold">Warning:</p>
                  <p className={`text-${alertinfo[0]?.severity_color}-800`}>
                    {alertinfo[0]?.warning_message}
                  </p>
                </div>
                <div className="mb-2">
                  <p className="text-gray-800 font-semibold">Start Time:</p>
                  <p className={`text-${alertinfo[0]?.severity_color}-800`}>
                    {alertinfo[0]?.effective_start_time}
                  </p>
                </div>
                <div>
                  <p className="text-gray-800 font-semibold">End Time:</p>
                  <p className={`text-${alertinfo[0]?.severity_color}-800`}>
                    {alertinfo[0]?.effective_end_time}
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="info-box bg-blue-100 p-4 rounded-md shadow-md mt-4 sm:w-[200px] md:w-[300px] lg:w-[400px]">
              <p>Alert not found </p>
            </div>
          )}
        </>
      ) : (
        <p>Fetching location...</p>
      )}
    </div>
  );
}
